import { IRowData, ArrayChangeTrackerContext } from 'rewire-ui';

export default class ProxyArrayChangeTrackerContext extends ArrayChangeTrackerContext {
  constructor(
    rows: IRowData[],
    isComplete: (value: any) => boolean = () => true,
    public depth: number = 2,
  ) {
    super(rows, isComplete);
  }

  setRow(index: number, value: IRowData): void {
    const obj = this.getRow(index);
    if (!obj) {
      super.setRow(index, value);
      return;
    }
    for (const member in obj) {
      if (!Object.prototype.hasOwnProperty.call(value, member)) {
        delete (obj as any)[member];
      }
    }
    Object.assign(obj, value);
  }
}
